
module.directive('newStudentActivityForm', function(ModelService) {
    return  {
        restrict: 'E',
        templateUrl: 'students/activities/newStudentActivityForm',
        scope: {participantId: '='},
        require: '^basicForm',
        link: function(scope, element, attrs, basicForm) {
            scope.data = basicForm.data = {};
            scope.form = basicForm.getForm();

            basicForm.save = function(data) {
                ModelService.postRelation('participant', scope.participantId,
                                          'activities', data);
            };
        },
    };
});

module.directive('studentActivityForm', function(ModelService) {
    return  {
        restrict: 'E',
        templateUrl: 'students/activities/studentActivityForm',
        scope: {activity: '=', canDelete:'='},
        require: '^basicForm',
        link: function(scope, element, attrs, basicForm) {
            scope.data = basicForm.data = ModelService.copyFields(scope.activity);
            scope.form = basicForm.getForm();

            basicForm.save = function(data) {
                ModelService.patchModel(scope.activity, data);
            };

            basicForm.setDeleteFunctions(function() {
                return ModelService.deleteModel(scope.activity);
            }, function() {
                return scope.canDelete;
            });
        },
    };
});